module.exports = __webpack_public_path__ + "dist/assets/img/bige-icon-like.519bbe96.svg";